import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LOOKS = {
  // Rounded stage pill (Leads).
  pill: "h-6 min-w-[64px] rounded-full border px-2 text-[10px] font-medium [&>svg]:h-3 [&>svg]:w-3",
  // Same chrome as the static status Badge on the Work Orders list, plus a small chevron.
  badge: "h-5 rounded-md border border-transparent px-2.5 text-[10px] font-semibold [&>svg]:h-3 [&>svg]:w-3",
};

// Clickable status pill — one look for every inline stage / status / temp picker. options: [{ value, label, pill }]
export default function PillSelect({ value, options, onChange, testId, optionTestId, placeholder = "—", title, look = "pill", className = "" }) {
  const current = options.find((o) => o.value === value);
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger title={title}
        className={`w-auto gap-1 whitespace-nowrap py-0 shadow-none ${LOOKS[look] || LOOKS.pill} ${current?.pill || "bg-slate-100 text-slate-500 border-slate-200"} ${className}`}
        data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={optionTestId ? optionTestId(o.value) : undefined}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
